// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"10":"5f135cdd","106":"6d2feb39","112":"a30953f6","648":"7372e9f1","957":"65e69365"}[chunkId] + ".js";
};